import { tableTypeNameMapping } from "../../../constant/nameMapping";
import defaultImage from "../../../images/defaultImage.png";
import { getDefaultConfig } from "../../../utils/Config/getDefaultConfig";
// Result fields prepended to the send_email_bg mapping. At runtime the backend writes the
// actually-sent subject/body into the global field mapped to each of these keys.
export const EMAIL_RESULT_FIELDS = ["_RESULT_SUBJECT", "_RESULT_BODY"];

export const updateParamsOnChange = (params, requirements, key) => {
  const index = requirements.indexOf(key);
  if (index !== requirements.length - 1) {
    for (let i = index + 1; i < requirements.length; i++) {
      params[requirements[i]] = "";
    }
  }
};

export const getTypeOptions = (keyName, fieldType) => {
  const optionsMap = {
    "app-user": ["", "mapped", "self", "logged_in_manager"],
    navigate_variable_mapping: ["mapped", "hardcoded"],
    prefill_mapping: ["json_key", "mapped", "logged_in_user", "na", "hardcoded"],
    lookup: ["", "self", "manual", "mapped"],
    "lookup-sm": ["", "self", "manual", "mapped"],
    "linked-sm-lookup": ["", "self", "manual", "mapped"],
    target_user: ["", "self", "mapped"],
    scheduled_time: ["", "time_format", "mapped"],
    frequency: ["", "dropdown", "mapped"],
    time: ["mapped", "manual", "hardcoded", "logic", "time_format", "na"],
    default: ["mapped", "manual", "hardcoded", "logic", "na", "mapped_http_response"]
  };

  const labelMap = {
    "": "Select type",
    mapped: "Mapped",
    manual: "Manual",
    hardcoded: "Hardcoded Value",
    logic: "Logic-Based",
    self: "Self",
    logged_in_manager: "Logged-In Manager",
    logged_in_user: "Logged-In User",
    json_key: "JSON Key",
    dropdown: "Dropdown List",
    time_format: "Time Format",
    mapped_http_response: "Mapped HTTP Response",
    na: "NA"
  };

  const options = optionsMap[fieldType] || optionsMap[keyName] || optionsMap.default;

  return (
    <>
      {options.map((value, index) => (
        <option key={index} value={value}>
          {labelMap[value] || value}
        </option>
      ))}
    </>
  );
};

export const getLabelName = (keyName) => {
  const labelMap = {
    sm_id: tableTypeNameMapping("statemachine"),
    entity_id: "Entity",
    detailsview_id: "Detailsview",
    recordsview_id: "Recordsview",
    lookup_field_map: "Lookup",
    select_table: "Table",
    where_column: "Table Field To Insert Instance Id",
    name: "Screen",
    doc_template_ids: "Document",
    light_lookup: "Light Lookup",
    mobile_screen: "Mobile Screen",
    desktop_screen: "Desktop Screen",
    mongo_template: "Mongo Template",
    navigate_with_token: "Navigate With Token",
    pro_code_id: "Pro Code",
    grid_id: "Rich Grid",
    pre_filter: "Pre Filters",
    group_ids: "Groups",
    // community_group_ids: "Community Groups",
    frequency: "Frequency",
    is_a_thread: "Is a Thread",
    mass_performable: "Mass Activity Enabled",
    is_background: "Is Background",
    refresh_delay_time: "Refresh Delay (in milliseconds)"
  };

  const activityKeys = ["activity_id", "activity_id_init", "all_activity_id", "system_activity_id"];

  const templateKeys = [
    "email_template_id",
    "sms_template_id",
    "document_template_id",
    "googledoc_template_id",
    "exceldoc_template_id",
    "ocr_template_id"
  ];

  if (activityKeys.includes(keyName)) return "Activity";
  if (templateKeys.includes(keyName)) return "Template";

  return labelMap[keyName] || keyName.replace(/_/g, " ");
};

export const getDefaultTypeOfMapping = (type, jobTemplate) => {
  let status = "";
  switch (jobTemplate) {
    case "perform_activity":
    case "start_state_machine":
    case "register_entity":
    case "start_state_machine_offline":
    case "edit_entity_fe":
    case "perform_activity_rdbms_fe":
      status = "manual";
      break;
    case "edit_sm_bg":
    case "edit_entity_bg":
    case "edit_self_entity_bg":
    case "prefill_mapping":
    case "make_http_request":
      status = "na";
      break;
    case "grid_to_json":
      status = "hardcoded";
      break;
    default:
      status = "mapped";
      break;
  }

  switch (type) {
    case "lookup":
      status = "";
      break;
    default:
      break;
  }

  return status;
};

export const getElementConfig = (element) => {
  const { type, name, id } = element;

  switch (type) {
    case "button":
    case "button-group":
    case "dropdown":
    case "dropdown-navigate":
    case "dv-group":
    case "icon":
      return getDefaultConfig(type);

    case "html":
      return { type, name, content: "" };

    case "image":
      return { type, name, source: defaultImage };

    case "label":
      return { type, name, icon: "" };

    case "spacer":
      return { type, name, height: 50 };

    case "form":
      return { name, type, config: getDefaultConfig("button") };

    default:
      return { type, id, name };
  }
};

export const getLabelNameForTheJobMapping = (keyName) => {
  const labelMap = {
    variable_mapping: "Variable Mapping",
    app_user_id_mapping: "App User ID Mapping",
    prefill_mapping: "Prefill Mapping",
    sm_variable_mapping: "Screen Variable Mapping",
    entity_variable_mapping: "Entity Variable Mapping",
    entity_global_variable_mapping: "Entity Global Variable Mapping",
    parent_sm_variable_mapping: "Parent Screen Variable Mapping",
    query_variable_mapping: "Query Variable Mapping",
    body_variable_mapping: "Body Variable Mapping",
    header_variable_mapping: "Header Variable Mapping",
    output_variable_mapping: "Output Variable Mapping",
    url_variable_mapping: "URL Variable Mapping",
    grid_json_variable_mapping: "Grid JSON Variable Mapping"
  };

  return labelMap[keyName] || "Mapping";
};
